import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const objections = [{
  myth: 'Preciso saber fazer artesanato',
  truth: 'Não precisa. As ideias são pensadas para quem não tem habilidade manual. Se você consegue colar, amarrar e organizar, você consegue fazer.'
}, {
  myth: 'Preciso de ferramentas especiais',
  truth: 'Não precisa. Você vai usar coisas que já tem em casa ou que custam poucos reais em qualquer papelaria.'
}, {
  myth: 'Preciso de muito tempo livre',
  truth: 'Não precisa. A maioria das ideias leva menos de 5 minutos por unidade. Você pode fazer aos poucos, no seu ritmo.'
}, {
  myth: 'Preciso ser criativa',
  truth: 'Não precisa. A criatividade já foi feita por você. Basta seguir o passo a passo exatamente como está.'
}];
export function ObjectionSection() {
  return <section className="py-24 bg-white" data-id="element-112">
      <div className="max-w-5xl mx-auto px-6" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-114">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-115">
            "E se eu não levar jeito?"
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-116">
            Esta é a dúvida mais comum. E a resposta vai te surpreender.
          </p>
        </motion.div>

        <div className="space-y-6 mb-12" data-id="element-117">
          {objections.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-118">
              <div className="grid md:grid-cols-2 gap-6" data-id="element-119">
                <div className="flex items-start gap-4" data-id="element-120">
                  <div className="bg-red-100 p-2 rounded-full flex-shrink-0" data-id="element-121">
                    <X className="w-5 h-5 text-red-600" data-id="element-122" />
                  </div>
                  <div data-id="element-123">
                    <p className="text-sm font-semibold text-gray-500 mb-1 uppercase tracking-wide" data-id="element-124">
                      Mito
                    </p>
                    <p className="text-lg text-gray-700 font-medium" data-id="element-125">
                      {item.myth}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-126">
                  <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-127">
                    <Check className="w-5 h-5 text-green-600" data-id="element-128" />
                  </div>
                  <div data-id="element-129">
                    <p className="text-sm font-semibold text-gray-500 mb-1 uppercase tracking-wide" data-id="element-130">
                      Verdade
                    </p>
                    <p className="text-lg text-gray-700" data-id="element-131">{item.truth}</p>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="text-center" data-id="element-132">
          <p className="text-lg text-gray-600 italic" data-id="element-133">
            "Este guia já foi testado e aprovado por dezenas de noivas reais que
            também achavam que não levavam jeito."
          </p>
        </motion.div>
      </div>
    </section>;
}